import React, { useEffect, useState } from "react";
import { Box, Typography, Button, useTheme, Skeleton } from "@mui/material";

import withAuth from "../../hoc/withAuth"; // Ensure the correct path to withAuth
import { PlaylistAdd } from "@mui/icons-material";
import {
  AppBanner,
  GetTrendingVideos,
  TrendingVideos,
  GetBannerList,
  FreeBiesHome,
  GetFreeBiesHome,
  RemoveBanner,
  RemoveTrendingVideo,
  RemoveFreebie,
} from "../../services/ContentManagementService";

import DrawerBanerManagement from "./DrawerBanerManagement";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import DrawerFreebieManagement from "./DrawerFreebieManagement";
import DrawerTrendingVideoManagement from "./DrawerVideoManagement";

const AppBanners = () => {
  const theme = useTheme();
  // State for trending videos

  return (
    <Box
      sx={{
        padding: 2,
        // border: "2px solid red",
        maxHeight: "90vh",
        overflowY: "scroll",
        scrollbarWidth: "none",
      }}
    >
      <Typography variant="h4" gutterBottom>
        App Config
      </Typography>
      <BannerManagement />
      <FreeBiesHomeManagement />
      <TrendingVideoManagement />
    </Box>
  );
};

export default withAuth(AppBanners);

const BannerManagement = () => {
  const [bannerManagementDrawerOpen, setBannerManagementDrawerOpen] =
    useState<boolean>(false);
  const [selectedBanner, setSelectedBanner] = useState<AppBanner>();
  const [banners, setBanners] = useState<AppBanner[]>([]);
  const [position, setPosition] = useState<number>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchBannerList();
  }, []);

  const fetchBannerList = async () => {
    setIsLoading(true);

    const result = await GetBannerList();
    if (result) {
      const sortedBanners = Array(3).fill(null);
      result.forEach((banner: AppBanner) => {
        if (banner.position >= 0 && banner.position < 3) {
          sortedBanners[banner.position] = banner;
        }
      });
      setBanners(sortedBanners);
    } else {
      setBanners(Array(3).fill(null));
    }
    setIsLoading(false);
  };

  const reloadBannerList = async () => {
    await fetchBannerList();
  };

  const onBannerManagementClose = () => {
    setBannerManagementDrawerOpen(false);
  };
  const onBannerManagementOpen = () => {
    setBannerManagementDrawerOpen(true);
  };

  const handleBannerClick = (banner: AppBanner, index: number) => {
    setSelectedBanner(banner);
    setPosition(index);
    onBannerManagementOpen();
  };

  const handleRemove = async (banner: AppBanner): Promise<number> => {
    const id = banner.id;
    const status = await RemoveBanner(id);
    if (status == 200) {
      await reloadBannerList();
      setSelectedBanner(undefined);

      return 200;
    } else {
      return 401;
    }
  };

  return (
    <Box marginBottom={3} marginTop={3}>
      <Typography variant="h6" color={"gray"} gutterBottom>
        <b>Banners : </b>
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          width: "70%",
          // maxWidth: 1200,
          // border: "1px solid red",
          marginY: 2,
        }}
      >
        {isLoading &&
          Array.from({ length: 3 }).map((_, index) => (
            <SkeletonCard key={index} />
          ))}

        {!isLoading &&
          banners.map((banner, index) => (
            <Box
              key={index}
              sx={{
                position: "relative",
                width: "23%",
                aspectRatio: "16 / 9",
                backgroundColor: banner ? "transparent" : "gray",
                border: `1.5px solid  grey[400]`, // Highlight selected banner
                display: "flex",
                marginRight: 2,
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              {banner ? (
                <Box
                  component="img"
                  src={banner.photoUrl}
                  alt={`Banner ${index + 1}`}
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <Button
                  variant="contained"
                  component="label"
                  onClick={() => handleBannerClick(banner, index)}
                >
                  <AddToPhotosIcon />
                </Button>
              )}
              {banner && (
                <Button
                  variant="contained"
                  component="label"
                  sx={{
                    position: "absolute",
                    bottom: 8,
                    right: 8,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                  }}
                  onClick={() => handleBannerClick(banner, index)}
                >
                  view
                </Button>
              )}
            </Box>
          ))}

        <DrawerBanerManagement
          open={bannerManagementDrawerOpen}
          onClose={onBannerManagementClose}
          banner={selectedBanner as AppBanner}
          position={position as 0 | 1 | 2}
          onUpdate={reloadBannerList}
          onRemove={handleRemove}
        />
      </Box>
    </Box>
  );
};

const TrendingVideoManagement = () => {
  const [videoManagementDrawerOpen, setVideoManagementDrawerOpen] =
    useState<boolean>(false);
  const [trendingVideos, setTrendingVideos] = useState<TrendingVideos[]>([]);
  const [videoPosition, setVideoPosition] = useState<0 | 1 | 2 | 3>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchTrendingVideos();
  }, []);

  const fetchTrendingVideos = async () => {
    setIsLoading(true);
    const result = await GetTrendingVideos();
    if (result) {
      const sortedVideos = Array(4).fill(null);
      result.forEach((video: any) => {
        if (video.position >= 0 && video.position < 4) {
          sortedVideos[video.position] = video;
        }
      });
      setTrendingVideos(sortedVideos);
    } else {
      setTrendingVideos(Array(4).fill(null));
    }
    setIsLoading(false);
  };

  const handleVideoClick = (video: any, index: 0 | 1 | 2 | 3) => {
    setVideoPosition(index);
    onVideoManagementOpen();
  };

  const onVideoManagementClose = () => {
    setVideoManagementDrawerOpen(false);
  };

  const onVideoManagementOpen = () => {
    setVideoManagementDrawerOpen(true);
  };

  const reloadTrendingVideos = async () => {
    await fetchTrendingVideos();
  };

  const handleRemove = async (id: string) => {
    const status = await RemoveTrendingVideo(id);
    if (status == 200) {
      await reloadTrendingVideos();
      return 200;
    } else {
      return 401;
    }
  };

  return (
    <Box marginY={3}>
      <Typography variant="h6" color={"gray"} gutterBottom>
        <b>Trending Videos : </b>
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          width: "70%",
          // maxWidth: 1200,
          marginY: 2,
        }}
      >
        {isLoading &&
          Array.from({ length: 4 }).map((_, index) => (
            <SkeletonCard key={index} />
          ))}

        {!isLoading &&
          trendingVideos.map((trendingVideo, index) => {
            return (
              <Box key={index} width={"23%"} marginRight={2}>
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    aspectRatio: "16 / 9",
                    backgroundColor: trendingVideo ? "transparent" : "gray",
                    border: "1.5px solid grey[400]",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                  }}
                >
                  {trendingVideo ? (
                    <Box
                      component="img"
                      src={trendingVideo.video.thumbnailUrl}
                      alt={`Video ${index + 1}`}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <Button
                      variant="contained"
                      component="label"
                      onClick={() =>
                        handleVideoClick(trendingVideo, index as 0 | 1 | 2 | 3)
                      }
                    >
                      <VideoCallIcon />
                    </Button>
                  )}
                  {trendingVideo && (
                    <Button
                      variant="contained"
                      component="label"
                      sx={{
                        position: "absolute",
                        bottom: 8,
                        right: 8,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        color: "white",
                      }}
                      onClick={() => handleRemove(trendingVideo.id)}
                    >
                      Remove
                    </Button>
                  )}
                </Box>

                {trendingVideo && (
                  <Box display={"flex"} marginTop={2}>
                    {/* <Box
                      component="img"
                      src={trendingVideo.video.thumbnailUrl}
                      alt={`Video ${index + 1}`}
                      sx={{
                        width: 40,
                        height: 40,
                        objectFit: "cover",
                        borderRadius: "50%",
                        marginRight: 2,
                      }}
                    /> */}
                    <Typography variant="body2" color={"gray"}>
                      <b>{trendingVideo.video.title.slice(0, 25)}</b> <br />
                      {/* {freebie.playList.description.slice(0, 50)} */}
                      {/* <b>{trendingVideo.video.totalLikes}</b> Likes &{" "} */}
                      {/* <b>{trendingVideo.video.totalComments}</b> Comments */}
                    </Typography>
                  </Box>
                )}
              </Box>
            );
          })}

        <DrawerTrendingVideoManagement
          open={videoManagementDrawerOpen}
          onClose={onVideoManagementClose}
          onUpdate={reloadTrendingVideos}
          position={videoPosition as 0 | 1 | 2 | 3}
        />
      </Box>
    </Box>
  );
};

const FreeBiesHomeManagement = () => {
  const [freebiesDrawerOpen, setFreebiesManagementDrawerOpen] =
    useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [freeBies, setFreebies] = useState<FreeBiesHome[]>([]);
  const [freebiePosition, setfreebiePosition] = useState<0 | 1 | 2 | 3>();

  useEffect(() => {
    fetchFreeBiesHome();
  }, []);

  const fetchFreeBiesHome = async () => {
    // Replace with actual fetching logic
    setIsLoading(true);
    const result = await GetFreeBiesHome();
    if (result) {
      const sortedVideos = Array(4).fill(null);
      result.forEach((freebie: any) => {
        if (freebie.position >= 0 && freebie.position < 4) {
          sortedVideos[freebie.position] = freebie;
        }
      });
      setFreebies(sortedVideos);
    } else {
      setFreebies(Array(4).fill(null));
    }
    setIsLoading(false);
  };

  const reloadFreeBiesHome = async () => {
    await fetchFreeBiesHome();
  };
  const handleVideoClick = (index: 0 | 1 | 2 | 3) => {
    setfreebiePosition(index);
    onFreeBiesManagementOpen();
  };

  const onFreeBiesManagementClose = () => {
    setFreebiesManagementDrawerOpen(false);
  };

  const onFreeBiesManagementOpen = () => {
    setFreebiesManagementDrawerOpen(true);
  };

  const handleRemove = async (id: string) => {
    const status = await RemoveFreebie(id);
    if (status == 200) {
      reloadFreeBiesHome();
      return 200;
    } else {
      return 401;
    }
  };
  return (
    <Box marginY={3}>
      <Typography variant="h6" color={"gray"} gutterBottom>
        <b>Freebies on Home (available for free) : </b>
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          width: "70%",
          // maxWidth: 1200,
          marginY: 2,
        }}
      >
        {isLoading &&
          Array.from({ length: 4 }).map((_, index) => (
            <SkeletonCard key={index} />
          ))}

        {!isLoading &&
          freeBies.map((freebie, index) => {
            if (!freeBies) {
              return (
                <>
                  <SkeletonCard key={index} />;
                </>
              );
            }
            return (
              <Box key={index} width={"23%"} marginRight={2}>
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    aspectRatio: "16 / 9",
                    backgroundColor: freebie ? "transparent" : "gray",
                    border: "1.5px solid grey[400]",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                  }}
                >
                  {freebie ? (
                    <>
                      <Box
                        component="img"
                        src={freebie.playList.thumbnailUrl}
                        alt={`Video ${index + 1}`}
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </>
                  ) : (
                    <Button
                      variant="contained"
                      component="label"
                      onClick={() => handleVideoClick(index as 0 | 1 | 2 | 3)}
                    >
                      <PlaylistAdd />
                    </Button>
                  )}
                  {freebie && (
                    <Button
                      variant="contained"
                      component="label"
                      sx={{
                        position: "absolute",
                        bottom: 8,
                        right: 8,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        color: "white",
                      }}
                      onClick={() => handleRemove(freebie.id)}
                    >
                      Remove
                    </Button>
                  )}
                </Box>

                {freebie && (
                  <Box display={"flex"} marginTop={2}>
                    {/* <Box
                      component="img"
                      src={freebie.playList.thumbnailUrl}
                      alt={`Video ${index + 1}`}
                      sx={{
                        width: 40,
                        height: 40,
                        objectFit: "cover",
                        borderRadius: "50%",
                        marginRight: 2,
                      }}
                    /> */}
                    <Typography variant="body2" color={"gray"}>
                      <b>{freebie.playList.name}</b> <br />
                      {/* {freebie.playList.description.slice(0, 50)} */}
                      {/* <b>{freebie.playList.videos.length}</b> videos */}
                    </Typography>
                  </Box>
                )}
              </Box>
            );
          })}

        <DrawerFreebieManagement
          open={freebiesDrawerOpen}
          onClose={onFreeBiesManagementClose}
          onUpdate={reloadFreeBiesHome}
          position={freebiePosition as 0 | 1 | 2 | 3}
        />
      </Box>
    </Box>
  );
};

const SkeletonCard = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "23%",
        aspectRatio: "16 / 9",
        backgroundColor: "gray",
        // border: `1.5px solid ${orange[300]}`, // You can adjust this based on the logic for the skeleton
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginRight: 2,
        overflow: "hidden",
      }}
    >
      <Skeleton variant="rectangular" width="100%" height="100%" />
    </Box>
  );
};
